export default __webpack_public_path__ + "static/media/tour-access-alarm-on.30c7d25c.svg";